/**
 * The landing's mood picker (apps/landing/src/components/MoodPicker.astro) for the prototypes: the four moods v2,
 * ?mood=<id> in the URL, the last pick remembered. Same file in prototypes/anillo-liquido and prototypes/colibri-particulas.
 * dot = accent for dots and glows, rim = accent readable on the dark ink, solid = accent that holds white text / reads on white.
 */
export const moods = {
    cobriza: { name: 'Cobriza', dot: '#AA7531', rim: '#D19A55', solid: '#8F5F22' },
    fuego: { name: 'Fuego', dot: '#E2531C', rim: '#FF8A5B', solid: '#C2410C' },
    manglar: { name: 'Manglar', dot: '#66A798', rim: '#86D9D4', solid: '#3C7264' },
    gorgimorado: { name: 'Gorgimorado', dot: '#6357E7', rim: '#7B97E6', solid: '#6357E7' }
}

const css = `
.moods { position: fixed; z-index: 20; left: 50%; bottom: max(1rem, env(safe-area-inset-bottom)); transform: translateX(-50%);
    display: flex; gap: 0.25rem; padding: 0.3rem; border-radius: 999px; background: rgb(11 16 32 / 0.88);
    backdrop-filter: blur(8px); box-shadow: 0 6px 24px rgb(0 0 0 / 0.25); }
.moods button { display: flex; align-items: center; gap: 0.45rem; min-height: 2.75rem; padding: 0 0.85rem; border: 0; border-radius: 999px;
    background: transparent; color: #C9CED8; font: 500 14px/1 'Avenir Next', Avenir, system-ui, sans-serif; cursor: pointer; }
.moods button[aria-pressed='true'] { background: rgb(255 255 255 / 0.12); color: #fff; }
.moods .swatch { width: 1rem; height: 1rem; border-radius: 50%; flex: none; box-shadow: 0 0 0 2px rgb(255 255 255 / 0.15); }
@media (max-width: 520px) { .moods button:not([aria-pressed='true']) .name { display: none; } }
`

export const currentMood = () =>
{
    let id = new URLSearchParams(location.search).get('mood')
    try { id = id || localStorage.getItem('mobita-mood') } catch {}
    return moods[id] ? id : 'gorgimorado'
}

export const mountMoodPicker = (onChange) =>
{
    const style = document.createElement('style')
    style.textContent = css
    document.head.append(style)
    const picker = document.createElement('div')
    picker.className = 'moods'
    picker.setAttribute('role', 'group')
    picker.setAttribute('aria-label', 'Mood')
    for(const [id, { name, dot }] of Object.entries(moods))
    {
        const button = document.createElement('button')
        button.type = 'button'
        button.dataset.mood = id
        button.innerHTML = `<span class="swatch" style="background:${dot}"></span><span class="name">${name}</span>`
        picker.append(button)
    }
    document.body.append(picker)

    const select = (id) =>
    {
        picker.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mood === id)))
        onChange(moods[id], id)
    }
    picker.addEventListener('click', (event) =>
    {
        const id = event.target.closest('button')?.dataset.mood
        if(!id) return
        try { localStorage.setItem('mobita-mood', id) } catch {}
        const params = new URLSearchParams(location.search)
        params.set('mood', id)
        history.replaceState(null, '', `${location.pathname}?${params}${location.hash}`)
        select(id)
    })
    select(currentMood())
}
